import { useEffect, useState } from "react"
import { IMG } from "../common/CONST"
import { InnPopUpList } from "../admin/inn/InnPopUpList"
import { useStore } from "../../stores/RootStoreContext"
import { IPageResponse } from "../../types/IPageResponse"
import { ICheckActionRequiredResponse } from "../../types/messenger/ICheckActionRequiredResponse"
import * as TrinityAPI from "../../requests/TrinityAPI"
import { CONFIG } from "../../CONFIG"
import { CurrencyPayerPopUpList } from "../admin/currencyPayer/CurrencyPayerPopUpList"

export const ManagerQuickActions = () => {
  const { userStore } = useStore()

  const [showInn, setShowInn] = useState(false)
  const [showCurrencyPayer, setShowCurrencyPayer] = useState(false)
  const [numInn, setNumInn] = useState<number>(0)
  const [numCurrencyPayer, setNumCurrencyPayer] = useState<number>(0)

  const fetchUnread = () => {
    TrinityAPI.getActionsRequired(response => {
      if (response.status === 200) {
        const actionRequiredList: IPageResponse<ICheckActionRequiredResponse> = response.data
        let innCount = 0
        let currencyPayerCount = 0
        actionRequiredList.items.forEach(i => {
          innCount += i.type === "INN" ? i.num : 0
          currencyPayerCount += i.type === "CURRENCY_PAYER" ? i.num : 0
        })
        setNumInn(innCount)
        setNumCurrencyPayer(currencyPayerCount)
      }
    })
  }

  useEffect(() => {
    fetchUnread()

    const intervalId = setInterval(() => {
      fetchUnread()
    }, CONFIG.fetchUnreadsInterval)

    return () => {
      clearInterval(intervalId)
    }
  }, [])

  return (
    <>
      <section className="quick-actions">
        {userStore.isManagerReq ? (
          <div className="quick-action-block" onClick={() => (window.location.href = "/request")}>
            <div className="quick-action-icon">
              <img src={IMG.requests} alt="" className="header-chapter-img" />
            </div>
            <p className="quck-action-text">Каталог запросов</p>
          </div>
        ) : (
          <></>
        )}
        {userStore.isManagerReq ? (
          <>
            <div className="quick-action-block" onClick={() => (window.location.href = "/replenishment")}>
              <div className="quick-action-icon">
                <img src={IMG.deals} alt="" className="header-chapter-img" />
              </div>
              <p className="quck-action-text">Каталог рублевых пополнений</p>
            </div>
            <div className="quick-action-block" onClick={() => (window.location.href = "/currency-replenishment")}>
              <div className="quick-action-icon">
                <img src={IMG.deals} alt="" className="header-chapter-img" />
              </div>
              <p className="quck-action-text">Каталог валютных пополнений</p>
            </div>
          </>
        ) : (
          <></>
        )}
        {userStore.isManagerOrd ? (
          <div className="quick-action-block" onClick={() => (window.location.href = "/order")}>
            <div className="quick-action-icon">
              <img src={IMG.orders} alt="" className="header-chapter-img" />
            </div>
            <p className="quck-action-text">Каталог ордеров</p>
          </div>
        ) : (
          <></>
        )}
        <div className="quick-action-block lock" id="admin10" onClick={() => setShowInn(true)}>
          <div className="quick-action-icon">
            <img src={IMG.lock} alt="" className="header-chapter-img" />
          </div>
          <p className="quck-action-text">
            Реестр рублевых плательщиков{" "}
            {numInn === 0 ? (
              ""
            ) : (
              <span
                className="span-actions"
                style={{
                  display: "inline-block",
                  marginLeft: "5px"
                }}
              >
                {numInn}
              </span>
            )}
          </p>
        </div>
        <div className="quick-action-block lock" id="admin10" onClick={() => setShowCurrencyPayer(true)}>
          <div className="quick-action-icon">
            <img src={IMG.lock} alt="" className="header-chapter-img" />
          </div>
          <p className="quck-action-text">
            Реестр валютных плательщиков{" "}
            {numCurrencyPayer === 0 ? (
              ""
            ) : (
              <span
                className="span-actions"
                style={{
                  display: "inline-block",
                  marginLeft: "5px"
                }}
              >
                {numCurrencyPayer}
              </span>
            )}
          </p>
        </div>
      </section>

      <InnPopUpList visible={showInn} setVisible={setShowInn} />
      <CurrencyPayerPopUpList visible={showCurrencyPayer} setVisible={setShowCurrencyPayer} />
    </>
  )
}
